import { Reducer } from 'redux';

import { ActionType } from 'store/types';

import { ILocationState, LocationActions } from './location.types';

export const initialState: ILocationState = {
  countries: undefined,
};

const reducer: Reducer<ILocationState, LocationActions> = (state = initialState, action): ILocationState => {
  switch (action.type) {
    case ActionType.SetCountries:
      return {
        ...state,
        countries: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
